const MktDashboard = () => {
  return <div>MktDashboard</div>;
};

export default MktDashboard;
